import React, { useEffect, useState } from 'react';

const FALLBACK_SRC = '/assets/images/no_image.png';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {
  const [currentSrc, setCurrentSrc] = useState(src || FALLBACK_SRC);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setCurrentSrc(src || FALLBACK_SRC);
    setFailed(false);
  }, [src]);

  return (
    <img
      src={currentSrc || FALLBACK_SRC}
      alt={alt}
      className={className}
      onError={() => {
        if (failed || currentSrc === FALLBACK_SRC) return;
        setFailed(true);
        setCurrentSrc(FALLBACK_SRC);
      }}
      {...props}
    />
  );
}

export default Image;
